// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#mobile-nav-bar {
    display: none;
}
#sidebar-menu-btn {
    display: none;
}
@media only screen and (max-width: 600px) {
    .mobile-nav-container {
        display: fixed;
        position: absolute;
        margin: 0;
        height: 100%;
        padding: 0;
        width: 0%;
        top: 0;
        left: 0;
        overflow: hidden;
        background-color: rgba(128, 128, 128, 0.4);
        z-index: 10;
        transition: width 500ms;
    }
    #mobile-nav-bar {
        display: flex;
        margin: 0;
        padding-top: 10%;
        height: 100%;
        width: 60%;
        overflow-x: hidden;
        background-color: rgba(128, 128, 128, 1);
    }
    .nav-bar {
        display: none;
    }
    .mobile-nav-btn {
        width: 100%;
        border-radius: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/mobile-sidebar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,UAAU;QACV,SAAS;QACT,MAAM;QACN,OAAO;QACP,gBAAgB;QAChB,0CAA0C;QAC1C,WAAW;QACX,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,UAAU;QACV,kBAAkB;QAClB,wCAAwC;IAC5C;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":["#mobile-nav-bar {\n    display: none;\n}\n#sidebar-menu-btn {\n    display: none;\n}\n@media only screen and (max-width: 600px) {\n    .mobile-nav-container {\n        display: fixed;\n        position: absolute;\n        margin: 0;\n        height: 100%;\n        padding: 0;\n        width: 0%;\n        top: 0;\n        left: 0;\n        overflow: hidden;\n        background-color: rgba(128, 128, 128, 0.4);\n        z-index: 10;\n        transition: width 500ms;\n    }\n    #mobile-nav-bar {\n        display: flex;\n        margin: 0;\n        padding-top: 10%;\n        height: 100%;\n        width: 60%;\n        overflow-x: hidden;\n        background-color: rgba(128, 128, 128, 1);\n    }\n    .nav-bar {\n        display: none;\n    }\n    .mobile-nav-btn {\n        width: 100%;\n        border-radius: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
